/**
 * The query parameters an interrupted navigation has to carry over to /login.
 *
 * Only `org`, the local-dev tenant override (`localhost?org=<slug>`). Angular
 * drops the querystring on a bare `createUrlTree(["/login"])`, and without it
 * the login would resolve to the staff door instead of the customer.
 *
 * Forwarding the whole querystring would drag an auth callback's own `code`
 * and `state` onto /login with it, so nothing else is carried. Customers are
 * created directly with a temporary password, so there are no invitation
 * parameters to carry any more (branded-login DECISION-005).
 */
const CARRIED_PARAMS = ["org"] as const;

export function loginRedirectParams(
  queryParams: Readonly<Record<string, unknown>>
): Record<string, string> {
  const carried: Record<string, string> = {};

  for (const key of CARRIED_PARAMS) {
    const value: unknown = queryParams[key];
    if (typeof value === "string" && value.length > 0) {
      carried[key] = value;
    }
  }

  return carried;
}
